import { FC, ReactNode } from 'react';

import { PreviewSessionContext } from './PreviewSessionContext';
import { usePreviewSessionManager } from './hooks/usePreviewSessionManager';

interface PreviewSessionProviderProps {
  children: ReactNode;
}

/**
 * Provider component for the Preview Session context.
 * Wraps the usePreviewSessionManager hook to provide centralized
 * session state management to all child components.
 *
 * @example
 * <PreviewSessionProvider>
 *   <App />
 * </PreviewSessionProvider>
 */
export const PreviewSessionProvider: FC<PreviewSessionProviderProps> = ({ children }) => {
  const manager = usePreviewSessionManager();

  return (
    <PreviewSessionContext.Provider value={manager}>{children}</PreviewSessionContext.Provider>
  );
};
